// src/data/team.js
import DipakImg  from '../assets/team/Dipak.png';
import JenilImg  from '../assets/team/Jenil.jpg';
import RahulImg  from '../assets/team/Rahul.png';
import SimranImg from '../assets/team/Simran.png';
import RanjanImg from '../assets/team/Ranjan.jpg';
import PrachiImg from '../assets/team/prachi.jpg';
import RahulWebDevImg from '../assets/team/Rahul_webdev.jpeg';

export const cofounders = [
  {
    name:     'Dipak Raval',
    role:     'Prototype Development Lead',
    image:    DipakImg,
    bio:      'Leads hardware and product prototyping, turning agritech concepts into real-world solutions that users can rely on.',
    email:    'rdvraval19@gmail.com',
    linkedin: 'https://www.linkedin.com/in/rdvraval19',
    github:   'https://github.com/rdvraval19',
  },
  {
    name:     'Rahul Khara',
    role:     'Research & Development Lead',
    image:    RahulImg,
    bio:      'Drives innovation through research in sustainable urban gardening, IoT integration, and cutting-edge green technologies.',
    email:    'Khararahul99@gmail.com',
    linkedin: 'https://www.linkedin.com/in/rahul-khara-147b4a2b7',
    github:   'https://github.com/Rahul23-byte',
  },
  {
    name:     'Jenil Sanchaniya',
    role:     'Operations Lead',
    image:    JenilImg,
    bio:      'Oversees day-to-day operations, ensuring seamless delivery of GROWTOPIA solutions to households, nurseries, and institutions across India.',
    email:    'freky.stark@gmail.com',
    linkedin: 'https://www.linkedin.com/in/frekystark',
    github:   'https://github.com/frekystark',
  },
];

export const teamMembers = [
  {
    name:     'Simran Patra',
    role:     'Graphic & Social Media Lead',
    image:    SimranImg,
    bio:      'Crafts GROWTOPIA\'s visual identity and social media presence, communicating our mission through compelling design.',
    email:    'simranpatra2021@gmail.com',
    linkedin: 'https://www.linkedin.com/in/simran-patra',
    github:   'https://github.com/Simran251393',
  },
  {
    name:     'Ranjan Kumar Sharma',
    role:     'Content Writer',
    image:    RanjanImg,
    bio:      'Tells the GROWTOPIA story through engaging content that educates urban gardeners and inspires sustainable green practices.',
    email:    'rs.ranjan79sharma@gmail.com',
    linkedin: 'https://www.linkedin.com/in/ranjan-kumar-sharma-910baa334',
    github:   'https://github.com/RanjanSharma09',
  },
  {
    name:     'Rahul Parmar',
    role:     'Web Developer',
    image:    RahulWebDevImg,
    bio:      'Builds and maintains GROWTOPIA\'s digital platforms, creating seamless experiences for urban gardeners and partners.',
    email:    'rahulpa2417r@gmail.com',
    linkedin: 'https://www.linkedin.com/in/rahul-parmar-735ab632a/',
    github:   'https://github.com/rahulp-fx',
  },
  {
    name:     'Prachi Parmar',
    role:     'Web Developer',
    image:    PrachiImg,
    bio:      'Develops intuitive interfaces and features that make gardening technology accessible and delightful for every user.',
    email:    'prachiparmar737@gmail.com',
    linkedin: 'https://www.linkedin.com/in/prachiparmar737',
    github:   'https://github.com/prachi737',
  },
];